module.exports = __webpack_public_path__ + "assets/img/ktz_title.c8a46546.png";